{
  "name": "ai-assistant",
  "version": "0.7.0",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "start:ssl": "ng serve --port 4201 --ssl --ssl-key ssl/server.key --ssl-cert ssl/server.crt",
    "build": "ng build",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "lint": "ng lint",
    "e2e": "ng e2e",
    "generate": "node_modules/.bin/ng-swagger-gen -i swagger.json -o ./src/app/data/api",
    "build:prod": "ng build --configuration production",
    "build:sandbox": "ng build --configuration sandbox",
    "cypress:run": "npx cypress run"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^20.3.13",
    "@angular/cdk": "^20.2.14",
    "@angular/common": "^20.3.13",
    "@angular/compiler": "^20.3.13",
    "@angular/core": "^20.3.13",
    "@angular/forms": "^20.3.13",
    "@angular/material": "^20.2.14",
    "@angular/platform-browser": "^20.3.13",
    "@angular/platform-browser-dynamic": "^20.3.13",
    "@angular/router": "^20.3.13",
    "@fortawesome/fontawesome-free": "^7.1.0",
    "@ng-bootstrap/ng-bootstrap": "^19.0.0",
    "@ng-idle/core": "^13.0.0",
    "@ng-idle/keepalive": "^13.0.0",
    "@ngx-pwa/local-storage": "^20.0.0",
    "bootstrap": "^5.3.8",
    "lodash-es": "^4.17.21",
    "marked": "^17.0.1",
    "ng-swagger-gen": "^2.3.1",
    "ngx-clipboard": "^15.1.0",
    "ngx-toastr": "^17.0.0",
    "rxjs": "~7.8.1",
    "tslib": "^2.3.0",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^20.3.11",
    "@angular/cli": "^20.3.11",
    "@angular/compiler-cli": "^20.3.13",
    "@types/jasmine": "~3.10.0",
    "@types/lodash-es": "^4.17.6",
    "@types/node": "^16.10.0",
    "https-proxy-agent": "^5.0.0",
    "jasmine-core": "~3.10.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.1.0",
    "karma-coverage": "~2.0.3",
    "karma-jasmine": "~4.0.0",
    "karma-jasmine-html-reporter": "~1.7.0",
    "typescript": "^5.8.0"
  }
}
